<template>
  <div class="footerTop">

    <div class="footerLeft">
      <p :style="lang==='zh'?'style=font-size:28px;text-indent: 38px;':'style=font-size:24px;'">{{lang==='zh'?'天津市赢事达办公用品厂':'Inkstar Office Appliance Factory Of Tianjin'}}</p>
      <p>{{lang==='zh'?'地址':'Address'}}：{{lang==='zh'?'天津市东丽区华明镇南坨工业园荣瑞路6号':'No.6 Rongrui Road, Nantuo Industrial Park, Huaming Town, Dongli District, Tianjin'}}</p>
    </div>
    <div class="footerRight">
      <p class="title">{{lang==='zh'?'联系我们':'Contact Us'}}</p>
      <p>{{lang==='zh'?'电话':'Telephone'}}：+86-022-84893989</p>
      <p>{{lang==='zh'?'邮箱':'Postbox'}}：inkstar@inkstar.cn</p>
      <p>{{lang==='zh'?'官网':'Official website'}}：www.inkstarttr.com</p>
    </div>
  </div>
  <div class="footer">
    Copyright ©  INKSTAR 天津市赢事达办公用品厂版权所有 |<a style="color:white;" href="https://beian.miit.gov.cn/#/Integrated/index">津ICP备19008329号-2</a>
  </div>
</template>

<script>
import Cookies from "js-cookie";
export default {
  name: "ysdFooter",
  data(){
    return{
      lang:"zh",
    }
  },
  mounted(){
    let lang = Cookies.get("lang")?Cookies.get("lang"):"zh";
    this.lang = lang;
    this.$i18n.locale = lang;
  }
}
</script>

<style scoped>
.footerTop{
  width:100%;
  display: flex;
  background: url("../../assets/footerBack.png") 100% 100% no-repeat;
  background-size: cover;
  height: 200px;
  justify-content: space-around;
  align-items: center;
  margin-top: 50px;
}

.footerTop>div{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.footerTop>div:first-child{
  width:45%;
}
.footerTop>div:last-child{
  width:55%;
}
.footerTop>div:first-child p{
  width:60%;
}
.footerTop>div p{
  font-size:18px;
  font-weight: bold;
  word-break: break-all;
  color:white;
  margin:5px 0;
}
.footerTop .title{
  font-size:24px!important;
}

  .footer{
    width:100%;
    background: rgb(38,38,38);
    color:white;
    display: flex;
    justify-content: center;
    align-items: center;
  }

@media screen and (max-width: 1000px){
  .footerTop{
    background: #333;
  }
  .footerTop p{
    font-size:16px!important;
  }
  .footerTop>div:first-child p{
    text-indent: 0!important;
  }
}
@media screen and (max-width: 670px){
  .footerTop{
    flex-direction: column;
    padding:15px 0;
  }
  .footerTop>div{
    width:100%!important;
  }
  .footerLeft p{
    text-align: center;
  }
  .footer{
    display: flex;
    flex-direction: column;
    text-align: center;
  }
}
</style>